import AudioPlayer from "../AudioPlayer";
import {useEffect, useRef, useState} from "react";
import ApiService from "../../core/service/api-service";
import {Button, Space, Table, Tooltip, Typography, Modal} from "antd";
import {useTranslation} from "react-i18next";
import {dateFormat} from "../../core/utils/date-utils";
import {PlayCircleOutlined} from "@ant-design/icons";
import AudioPlayer2 from "react-h5-audio-player";
import Flex from "../../core/components/Flex";
import {t} from "i18next";
import {PERMISSIONS} from "../../core/context/UserContext";
import DataGrid from "../../core/components/data-grid/DataGrid";
import {useDataGrid} from "../../core/components/data-grid/DataGridContext";
import StudyLogEnum from "./StudyLogEnum";

export default function StudyLogsGrid({studyId})
{
    const {setDataGridProps, queryModel, setData, setPaginationResult, refreshDataGrid} = useDataGrid()
    const [logs, setLogs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const {t} = useTranslation();

    const initDataGrid = async () => {
        const response = await ApiService.Study.GetStudyLogs({
            ...queryModel,
            filter: {
                studyId: studyId
            }
        });
        if(response.success)
        {
            setData(response.data)
            setPaginationResult(response.pagination)
        }
    }


    useEffect(() => {
        initDataGrid()
    }, [queryModel.updateKey])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            enableRowSelection: false,
            antdTableProps: {
                scroll: {}
            },
            columns: [
                {
                    title: t('Date'),
                    dataIndex: 'createdDate',
                    key: 'createdDate',
                    width: 150,
                    render: (text, record) => dateFormat(text)
                },
                {
                    title: t('Type'),
                    dataIndex: 'type',
                    key: 'type',
                    width: 250,
                    render: (text, record) => text
                },
                {
                    title: t('User'),
                    dataIndex: 'user',
                    key: 'user',
                    width: 400,
                    render: (text, record) => {
                        const vals = record?.user?.split('__')
                        if(vals?.length > 1)
                            return vals[1]

                        return '-'
                    }
                },
                {
                    title: t('Description'),
                    dataIndex: 'description',
                    key: 'description',
                    render: (text, record) => (
                        <Space>
                            {record?.description}
                            {record?.data && (
                                <Button size="small" onClick={() => { 
                                    try {
                                        setSelectedData(JSON.parse(record.data)); 
                                        setModalVisible(true); 
                                    } catch (e) {
                                        console.error('Invalid JSON', e);
                                    }
                                }}>
                                    View JSON
                                </Button>
                            )}
                        </Space>
                    )
                },
            ]
        })
    }, [])

    return (
        <>
            <DataGrid
                name={'study-logs'}
                mobileCardTitle={(record) => {
                    const userName = record?.user?.split('__')?.[1] || '-';
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontWeight: 600, fontSize: 13 }}>{record.type}</span>
                                <span style={{ fontSize: 11, color: '#888' }}>
                                    {dateFormat(record.createdDate)}
                                </span>
                            </div>
                            <div style={{ fontSize: 12, color: '#666' }}>
                                {t('User')}: {userName}
                            </div>
                            {record.description && (
                                <Typography.Text 
                                    ellipsis={{ tooltip: record.description }} 
                                    style={{ fontSize: 11, color: '#999', maxWidth: '100%' }}
                                >
                                    {record.description}
                                </Typography.Text>
                            )}
                        </div>
                    );
                }}
            />
            <Modal
                title="JSON Data"
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={null}
                width={800}
            >
                <pre>{JSON.stringify(selectedData, null, 2)}</pre>
            </Modal>
        </>
    )
}
